export const imageFileNameExtractor = (imagePath = "") => {
  const fileName1 = imagePath.substring(imagePath.lastIndexOf("/") + 1);
  return fileName1;
};
